export default "Optimisation chaufferie process — Fiche CEE IND-UT-115 | Solution Éco France";
